var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureNotificationsHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a30",
    x1: 9,
    y1: 0.81,
    x2: 9,
    y2: 21.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd70f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#eeb309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#dc8c03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d57d01"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5v10.83a.58.58 0 01-.59.58h-4.52a.14.14 0 00-.14.14v1.75a.28.28 0 01-.45.22l-2.72-2.08H1.09a.58.58 0 01-.59-.58V2.5a.58.58 0 01.59-.58h15.82a.58.58 0 01.59.58z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05 9l3 2.52a.29.29 0 00.47-.22v-1.1h11.96V8.5H2.23a.29.29 0 00-.18.5z",
    fill: "#ffe452"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.24 6.46l-3.11-2.52a.29.29 0 00-.47.22v1.1H.5V7h15.56a.29.29 0 00.18-.54z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureNotificationsHub);
export default __webpack_public_path__ + "static/media/azure-notificationsHub.74aeba656de6fb424f85b4a3db8d06ba.svg";
export { ForwardRef as ReactComponent };